import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';
import * as ActiveStorage from '@rails/activestorage';
import DateTimePickerController from './controllers/admin/datetime_picker_controller';
import DatePickerController from './controllers/admin/date_picker_controller';
import ImageFileController from './controllers/admin/image_file_controller';
import AdminLayoutController from './controllers/admin/layout_controller';
import RichTextController from './controllers/admin/rich_text_controller';
import RichTextViewerController from './controllers/admin/rich_text_viewer_controller';
import SortableController from './controllers/admin/sortable_controller';
import ContactFormController from './controllers/customer/stateful/contacts/contact_form_controller';
import TicketInquiryFormController from './controllers/customer/stateful/ticket_inquiries/ticket_inquiry_form_controller';
import AccordionController from './controllers/customer/stateless/accordion_controller';
import EventCarouselController from './controllers/customer/stateless/events/event_carousel_controller';
import EventConfirmationController from './controllers/customer/stateless/events/event_confirmation_controller';
import CustomerLayoutController from './controllers/customer/stateless/layout_controller';
import ScrollToTopController from './controllers/customer/stateless/scroll_to_top_controller';
import TopCarouselController from './controllers/customer/stateless/top/top_carousel_controller';

// Stimulusアプリケーションを起動
const application = Application.start();
ActiveStorage.start();

// Admin
application.register('admin-layout', AdminLayoutController);
application.register('datetime-picker', DateTimePickerController);
application.register('date-picker', DatePickerController);
application.register('sortable', SortableController);
application.register('image-file', ImageFileController);
application.register('rich-text', RichTextController);
application.register('rich-text-viewer', RichTextViewerController);

// Customer
application.register('customer-layout', CustomerLayoutController);
application.register('scroll-to-top', ScrollToTopController);
application.register('top-carousel', TopCarouselController);
application.register('event-carousel', EventCarouselController);
application.register('event-confirmation', EventConfirmationController);
application.register('ticket-inquiry-form', TicketInquiryFormController);
application.register('contact-form', ContactFormController);
application.register('accordion', AccordionController);
